import Page from '../components/modules/freight/Page';

const freight = [
  {
    path: '/freight/Page',
    name: 'Page',
    component: Page,
  },
];
export default freight;
